exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".link-list{margin:0;padding:0 4px;font-size:1.6rem;list-style:none}.link-list li+li{margin-top:3px}.link-list a{padding:0;font-style:italic}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/stylus-loader!./src/components/linklist/linklist.styl
// module id = 502
// module chunks = 0